import { Bird } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

interface EmptyResultProps {
  text?: React.ReactNode
  icon?: React.ReactNode
  className?: string
}

export const EmptyResult: React.FC<EmptyResultProps> = ({ text, icon, className }) => {
  return (
    <div
      className={twMerge(
        'flex h-[450px] flex-col items-center justify-center space-y-4 rounded border border-dashed',
        className
      )}
    >
      {icon ?? <Bird className="text-muted-foreground" size={40} />}
      <div className="text-semibold text-lg">{text ?? 'Nothing to see here yet.'}</div>
    </div>
  )
}
